<div class="latest-reviews-container">
  <div class="reviews-header">
    <h3 class="reviews-title">{{ 'Latest Reviews' | translate }}</h3>
    <a href="javascript:void(0)" class="view-all-link" *ngIf="hasMoreReviews && viewStatus === ViewStatus.READY"
      (click)="viewAllReviews()">
      {{ 'View all' | translate }}
    </a>
  </div>

  <div class="reviews-list" *ngIf="viewStatus === ViewStatus.READY && reviews.length > 0">
    <div class="review-item-wrapper" *ngFor="let review of reviews" (click)="reviewDetails(review)">
      <app-review [review]="review" [quotation]="false" class="review-item pointer">
      </app-review>
    </div>
  </div>

  <div class="empty-reviews" *ngIf="viewStatus === ViewStatus.READY && reviews.length === 0">
    <div class="text-center py-5">
      <div class="empty-icon mb-3">
        <i class="bi bi-star text-muted" style="font-size: 3rem;"></i>
      </div>
      <h6 class="fw-semibold mb-2">{{ 'No reviews yet' | translate }}</h6>
      <p class="text-muted small mb-0">{{ 'Be the first to share your experience with this clinic' | translate }}</p>
    </div>
  </div>

  <ng-container *ngIf="viewStatus === ViewStatus.LOADING">
    <div class="reviews-list">
      <ng-container *ngFor="let i of [1, 2, 3]">
        <div class="review-item-wrapper skeleton-wrapper">
          <div class="d-flex flex-row align-items-center justify-content-between mb-3">
            <div class="d-flex flex-row align-items-center gap-2" style="flex: 1;">
              <app-shimmer-loader size="30px" shape="circle"></app-shimmer-loader>

              <div class="d-flex flex-column gap-2" style="flex: 1;">
                <app-shimmer-loader height="14px" width="35%"></app-shimmer-loader>
                <app-shimmer-loader height="12px" width="25%"></app-shimmer-loader>
              </div>
            </div>
            <app-shimmer-loader height="25px" width="40px"></app-shimmer-loader>
          </div>

          <div class="d-flex flex-column gap-2">
            <app-shimmer-loader height="14px" width="100%"></app-shimmer-loader>

            <app-shimmer-loader height="14px" width="85%"></app-shimmer-loader>

            <app-shimmer-loader height="14px" width="40%"></app-shimmer-loader>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>